export default __webpack_public_path__ + "static/media/img-6.9603f378.jpg";